export default __webpack_public_path__ + "static/media/cloudy.c0b35de4.gif";